import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    backgroundColor: 'white',
    fontSize: theme.size.sm,
    border: `solid 1px #B64FCD`,
    padding: '0.5rem 0.75rem',
    cursor: 'default',

    [theme.breakpoints.up('sm')]: {
      minWidth: '344px !important'
    }
  },

  content: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    height: '100%',
    padding: '0.125rem'
  },

  header: {
    display: 'flex',
    alignItems: 'center',

    '& h1': {
      margin: '0',
      fontSize: theme.size.lg
    }
  },

  pill: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
    marginRight: '4px',
    borderRadius: '100rem',
    padding: '6px 10px',
    fontSize: theme.size.sm,
    userSelect: 'none',
    background: '#F8D8FF',
    border: `1px solid #B64FCD`,
    color: '#B64FCD',
    marginLeft: '1rem'
  },

  message: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0.5rem',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      paddingTop: '1rem'
    }
  },

  messageTextContainer: {
    display: 'flex',
    flexFlow: 'column',
    width: 300
  },

  messageTitle: {
    fontSize: theme.size.base
  },

  messageSubTitle: {
    marginTop: '0.5rem',
    fontSize: theme.size.base,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  messageSubTitleText: {
    minWidth: '5rem'
  },

  buttonContainer: {
    display: 'flex',

    [theme.breakpoints.down('md')]: {
      marginTop: 18,
      justifyContent: 'end'
    }
  },

  ignoreBtn: {
    fontSize: theme.size.base,
    width: 100,
    cursor: 'pointer',
    alignSelf: 'center',
    textAlign: 'center',
    padding: '6px 8px'
  }
}))

export default useStyles
